import { Directive, EventEmitter, Output, Input, ElementRef, HostListener } from '@angular/core';

@Directive({
  selector: '[txtbClickOutside]',
  standalone: false,
})
export class ClickOutsideDirective {
  @Output() clickOutside = new EventEmitter<void>();
  constructor(private elementRef: ElementRef) {}

  @HostListener('document:touchstart', ['$event'])
  @HostListener('document:mousedown', ['$event'])
  public onOutsideClick(event: MouseEvent | TouchEvent): void {
    const clickedInside = this.elementRef.nativeElement.contains(event.target);
    if (!clickedInside) {
      this.clickOutside.emit();
    }
  }
}
